import React, { memo } from 'react';
import { DynamicScommessaTipoProps, ScommessaKind } from 'components/scommesseTipo/types';

import { Scommessa as ScommesseTipoAntepost } from 'components/scommesseTipo/scommesseTipoAntepost/Scommessa';
import { Scommessa as ScommesseTipoEsitiOverThree } from 'components/scommesseTipo/scommesseTipoEsitiOverThree/Scommessa';
import { Scommessa as ScommesseTipoEsitiOverThreeEstesa } from 'components/scommesseTipo/scommesseTipoEsitiOverThreeEstesa/Scommessa';
import { Scommessa as ScommesseTipoEsitiOverThreeWithInfoAgg } from 'components/scommesseTipo/scommesseTipoEsitiOverThreeWithInfoAgg/Scommessa';
import { Scommessa as ScommesseTipoEsitiOverThreeWithInfoAggEstesa } from 'components/scommesseTipo/scommesseTipoEsitiOverThreeWithInfoAggEstesa/Scommessa';
import { Scommessa as ScommesseTipoEsitiUnderThree } from 'components/scommesseTipo/scommesseTipoEsitiUnderThree/Scommessa';
import { Scommessa as ScommesseTipoEsitiUnderThreeWithInfoAgg } from 'components/scommesseTipo/scommesseTipoEsitiUnderThreeWithInfoAgg/Scommessa';
import { Scommessa as ScommesseTipoEsitiUnderThreeWithInfoAggEstesa } from 'components/scommesseTipo/scommesseTipoEsitiUnderThreeWithInfoAggEstesa/Scommessa';
import { Scommessa as ScommesseTipoWithInfoAggMultiple } from 'components/scommesseTipo/scommesseTipoWithInfoAggMultiple/Scommessa';

// eslint-disable-next-line react/display-name
export const ScommessaTipo = memo(
  function (props: DynamicScommessaTipoProps): JSX.Element {
    const { scommessaTipo, ...params } = props;

    switch (scommessaTipo) {
      case ScommessaKind.ScommesseTipoAntepost: {
        return <ScommesseTipoAntepost {...params} />;
      }
      case ScommessaKind.ScommesseTipoEsitiOverThree: {
        return <ScommesseTipoEsitiOverThree {...params} />;
      }
      case ScommessaKind.ScommesseTipoEsitiUnderThree: {
        return <ScommesseTipoEsitiUnderThree {...params} />;
      }
      case ScommessaKind.ScommesseTipoWithInfoAggMultiple: {
        return <ScommesseTipoWithInfoAggMultiple {...params} />;
      }
      case ScommessaKind.ScommesseTipoEsitiOverThreeEstesa: {
        return <ScommesseTipoEsitiOverThreeEstesa {...params} />;
      }
      case ScommessaKind.ScommesseTipoEsitiOverThreeWithInfoAgg: {
        return <ScommesseTipoEsitiOverThreeWithInfoAgg {...params} />;
      }
      case ScommessaKind.ScommesseTipoEsitiUnderThreeWithInfoAgg: {
        return <ScommesseTipoEsitiUnderThreeWithInfoAgg {...params} />;
      }
      case ScommessaKind.ScommesseTipoEsitiUnderThreeWithBilanciata: {
        return <ScommesseTipoEsitiUnderThreeWithInfoAgg {...params} showOnlyBilanciata />;
      }
      case ScommessaKind.ScommesseTipoEsitiOverThreeWithInfoAggEstesa: {
        return <ScommesseTipoEsitiOverThreeWithInfoAggEstesa {...params} />;
      }
      case ScommessaKind.ScommesseTipoEsitiUnderThreeWithInfoAggEstesa: {
        return <ScommesseTipoEsitiUnderThreeWithInfoAggEstesa {...params} />;
      }
    }

    throw new Error(`scommessaTipo is required`);
  },
  (prevParams, nextParams) =>
    prevParams.scommessaKey === nextParams.scommessaKey &&
    prevParams.scommessaTipo === nextParams.scommessaTipo &&
    prevParams.infoAggiuntivaKey === nextParams.infoAggiuntivaKey
);